// extracted by mini-css-extract-plugin
module.exports = {"count-btn":"_20ON_gZSLX-M81Z_BkvRT2"};